import { FlexRow } from '@/components/common/Flex';
import { Box, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { useGoalDetailContext } from './GoalDetailContext';
import GoalStatementSection from './GoalStatementSection';

export default function GoalDetailStatementSection() {
    const { goal } = useGoalDetailContext();

    if (!goal) {
        return (
            <FlexRow py={4} px={16} gap={8}>
                <SkeletonCircle size="16" />
                <Box>
                    <Skeleton w={500} h={6} mb={3} />
                    <Skeleton w={300} h={6} />
                </Box>
            </FlexRow>
        );
    }

    return <GoalStatementSection py={12} px={16} />;
}
